import {downloadDocument} from "../../features/";

export function initDocumentPage() {

    const digitalDocuments = document.querySelectorAll('#digitalDocuments [data-href]');
    digitalDocuments.forEach(element => {
        element.addEventListener('click', documentClick);
    });

    /**
     * Handles the download logic for a document link. It retrieves the document URL from the data attribute and initiates the download process.
     *  ✅ Left-click → Downloads document via custom fetch logic, triggers CES after download
     *  ✅ Middle-click → Handle as left-click
     *  ✅ Ctrl+Click (or Cmd+Click on Mac) → Handle as left-click
     *  ✅ Right-click → Context menu is suppressed (no tracking confusion)
     * @param event
     * @returns {boolean}
     */
    function documentClick(event) {

        event.currentTarget.classList.add('loading');
        event.preventDefault();
        handleDownload(event.currentTarget);

        return false;
    }

    function handleDownload(targetElement) {

        let location = targetElement.getAttribute('data-href');

        return downloadDocument(location).then(() => {
            const cesKey = document.querySelector("[data-document-ces-key]")?.dataset?.documentCesKey;
            window.customerEffortScore.trigger(cesKey);

            targetElement.closest('tr')?.classList.remove('highlight');
        }).catch(error => {
            console.error('Error downloading document:', error);
            window.location.reload();
        }).finally(() => {
            targetElement.classList.remove('loading');
        });
    }
}